(function(root, factory) {
  'use strict';

  var controller = factory();
  if (typeof module === 'object' && module.exports) module.exports = controller;
  if (root) root.EnigmaWishlist = controller;
  if (root && root.document) controller.bind(root, root.document);
})(typeof window !== 'undefined' ? window : null, function() {
  'use strict';

  var WISHLIST_SELECTOR = '[data-icon-wishlist][data-product-handle]';
  var COOKIE_PREFERENCES_SELECTOR = '[data-enigma-cookie-preferences]';
  var STORAGE_KEY = 'wishListsArr';
  var PENDING_TTL_MS = 2 * 60 * 1000;
  var SINGLE_CARD_TYPES = {
    'magic single': true,
    'yugioh single': true,
    'one piece single': true,
    'dragon ball super singles': true,
    'pokÃ©mon single': true,
    'digimon single': true,
    'flesh and blood single': true
  };
  var documentStates = typeof WeakMap === 'function' ? new WeakMap() : null;
  var fallbackState = null;

  function createState() {
    return {
      allowed: false,
      consentKnown: false,
      consentUnavailable: false,
      consentGeneration: 0,
      pending: [],
      pageErrors: 0,
      pageLoaded: 0,
      pagePending: 0,
      productRequests: Object.create(null),
      renderGeneration: 0,
      ready: false,
      readyPromise: null,
      preferencesPromise: null,
      noticeTimer: null,
      replaying: null
    };
  }

  function stateFor(documentObject) {
    if (!documentStates || !documentObject) {
      if (!fallbackState) fallbackState = createState();
      return fallbackState;
    }
    var state = documentStates.get(documentObject);
    if (!state) {
      state = createState();
      documentStates.set(documentObject, state);
    }
    return state;
  }

  function privacyBannerFor(root) {
    if (root && root.privacyBanner) return root.privacyBanner;
    if (typeof privacyBanner !== 'undefined') return privacyBanner;
    return null;
  }

  function createPrivacyFallback(root, documentObject) {
    var apiPromise = null;

    function customerPrivacyApiFor(targetRoot) {
      var activeRoot = targetRoot || root;
      if (!activeRoot || !activeRoot.Shopify) return Promise.resolve(null);
      if (activeRoot.Shopify.customerPrivacy) {
        return Promise.resolve(activeRoot.Shopify.customerPrivacy);
      }
      if (typeof activeRoot.Shopify.loadFeatures !== 'function') return Promise.resolve(null);
      if (apiPromise) return apiPromise;

      apiPromise = new Promise(function(resolve) {
        try {
          activeRoot.Shopify.loadFeatures([
            { name: 'consent-tracking-api', version: '0.1' }
          ], function(error) {
            resolve(error ? null : (activeRoot.Shopify.customerPrivacy || null));
          });
        } catch (error) {
          resolve(null);
        }
      });
      return apiPromise;
    }

    function preferencesProcessingAllowedSync(targetRoot) {
      var activeRoot = targetRoot || root;
      var api = activeRoot && activeRoot.Shopify && activeRoot.Shopify.customerPrivacy;
      if (!api || typeof api.preferencesProcessingAllowed !== 'function') return false;
      try {
        return api.preferencesProcessingAllowed() === true;
      } catch (error) {
        return false;
      }
    }

    function preferencesProcessingAllowed(targetRoot) {
      var activeRoot = targetRoot || root;
      return customerPrivacyApiFor(activeRoot).then(function(api) {
        if (!api || typeof api.preferencesProcessingAllowed !== 'function') return false;
        try {
          return api.preferencesProcessingAllowed() === true;
        } catch (error) {
          return false;
        }
      }, function() {
        return false;
      });
    }

    function whenPreferencesAllowed(targetRoot, callback) {
      return preferencesProcessingAllowed(targetRoot || root).then(function(allowed) {
        if (!allowed || typeof callback !== 'function') return false;
        callback();
        return true;
      }, function() {
        return false;
      });
    }

    function openPreferences(targetRoot, targetDocument, trigger) {
      var activeRoot = targetRoot || root;
      var banner = privacyBannerFor(activeRoot);
      if (!banner || typeof banner.showPreferences !== 'function') {
        return Promise.resolve(false);
      }

      if (trigger && typeof trigger.setAttribute === 'function') {
        trigger.setAttribute('aria-busy', 'true');
      }
      var request;
      try {
        request = banner.showPreferences();
      } catch (error) {
        if (trigger && typeof trigger.removeAttribute === 'function') {
          trigger.removeAttribute('aria-busy');
        }
        return Promise.resolve(false);
      }

      return Promise.resolve(request).then(function() {
        if (trigger && typeof trigger.removeAttribute === 'function') {
          trigger.removeAttribute('aria-busy');
        }
        return true;
      }, function() {
        if (trigger && typeof trigger.removeAttribute === 'function') {
          trigger.removeAttribute('aria-busy');
        }
        return false;
      });
    }

    var fallback = {
      customerPrivacyApiFor: customerPrivacyApiFor,
      openPreferences: openPreferences,
      preferencesProcessingAllowed: preferencesProcessingAllowed,
      preferencesProcessingAllowedSync: preferencesProcessingAllowedSync,
      whenPreferencesAllowed: whenPreferencesAllowed
    };

    if (documentObject && !documentObject.__enigmaCustomerPrivacyBound) {
      documentObject.__enigmaCustomerPrivacyBound = true;
      documentObject.addEventListener('click', function(event) {
        var target = event && event.target;
        var trigger = target && typeof target.closest === 'function'
          ? target.closest(COOKIE_PREFERENCES_SELECTOR)
          : null;
        if (!trigger) return;
        if (typeof event.preventDefault === 'function') event.preventDefault();
        openPreferences(root, documentObject, trigger);
      });
      customerPrivacyApiFor(root);
    }

    return fallback;
  }

  function privacyControllerFor(root, documentObject) {
    if (root && root.EnigmaCustomerPrivacy) return root.EnigmaCustomerPrivacy;
    if (!root) return null;
    root.EnigmaCustomerPrivacy = createPrivacyFallback(root, documentObject);
    return root.EnigmaCustomerPrivacy;
  }

  function preferencesAllowedSync(root, documentObject) {
    return consentStatusSync(root, documentObject) === 'allowed';
  }

  function consentStatusFromApi(api) {
    if (!api || typeof api.preferencesProcessingAllowed !== 'function') return 'unknown';
    try {
      return api.preferencesProcessingAllowed() === true ? 'allowed' : 'denied';
    } catch (error) {
      return 'unknown';
    }
  }

  function consentStatusSync(root, documentObject) {
    privacyControllerFor(root, documentObject);
    var api = root && root.Shopify && root.Shopify.customerPrivacy;
    return consentStatusFromApi(api);
  }

  function normalizedHandles(value) {
    if (!Array.isArray(value)) return [];
    var seen = Object.create(null);
    return value.reduce(function(handles, item) {
      if (typeof item !== 'string') return handles;
      var handle = item.trim();
      if (!handle || seen[handle]) return handles;
      seen[handle] = true;
      handles.push(handle);
      return handles;
    }, []);
  }

  function readStoredHandles(root) {
    try {
      var raw = root.localStorage.getItem(STORAGE_KEY);
      return normalizedHandles(raw ? JSON.parse(raw) : []);
    } catch (error) {
      return [];
    }
  }

  function writeStoredHandles(root, handles) {
    try {
      root.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizedHandles(handles)));
      return true;
    } catch (error) {
      return false;
    }
  }

  function syncCount(documentObject, count) {
    if (!documentObject || typeof documentObject.querySelectorAll !== 'function') return;
    var badges = documentObject.querySelectorAll('.WishlistCount');
    Array.prototype.forEach.call(badges, function(badge) {
      var value = String(count);
      if (badge.textContent !== value) badge.textContent = value;
    });
  }

  function stringFor(root, key, fallback) {
    var strings = root && root.theme && root.theme.strings;
    return strings && strings[key] ? strings[key] : fallback;
  }

  function setAttributeIfChanged(element, name, value) {
    if (!element || typeof element.setAttribute !== 'function') return;
    var stringValue = String(value);
    if (typeof element.getAttribute !== 'function' || element.getAttribute(name) !== stringValue) {
      element.setAttribute(name, stringValue);
    }
  }

  function setControlState(root, control, added) {
    if (!control) return;
    if (control.classList) {
      var hasAddedClass = typeof control.classList.contains === 'function'
        && control.classList.contains('whislist-added');
      if (added && !hasAddedClass && typeof control.classList.add === 'function') {
        control.classList.add('whislist-added');
      } else if (!added && hasAddedClass && typeof control.classList.remove === 'function') {
        control.classList.remove('whislist-added');
      }
    }

    var label = added
      ? stringFor(root, 'remove_wishlist', 'Remove from wishlist')
      : stringFor(root, 'addto_wishlist', 'Add to wishlist');
    if (typeof control.querySelector === 'function') {
      var text = control.querySelector('.wishlist-text');
      if (text && text.textContent !== label) text.textContent = label;
    }
    setAttributeIfChanged(control, 'title', label);
    setAttributeIfChanged(control, 'data-original-title', label);
    setAttributeIfChanged(control, 'aria-pressed', added ? 'true' : 'false');
  }

  function syncControls(root, documentObject, handles) {
    if (!documentObject || typeof documentObject.querySelectorAll !== 'function') return;
    var controls = documentObject.querySelectorAll(WISHLIST_SELECTOR);
    Array.prototype.forEach.call(controls, function(control) {
      var handle = typeof control.getAttribute === 'function'
        ? String(control.getAttribute('data-product-handle') || '').trim()
        : '';
      setControlState(root, control, handles.indexOf(handle) >= 0);
    });
  }

  function removeWishlistCard(documentObject, handle) {
    if (!documentObject || typeof documentObject.querySelectorAll !== 'function') return;
    var cards = documentObject.querySelectorAll('[data-wishlist-added]');
    Array.prototype.forEach.call(cards, function(card) {
      var control = typeof card.querySelector === 'function'
        ? card.querySelector(WISHLIST_SELECTOR)
        : null;
      if (!control || String(control.getAttribute('data-product-handle') || '').trim() !== handle) return;
      if (typeof card.remove === 'function') card.remove();
      else if (card.parentNode) card.parentNode.removeChild(card);
    });
  }

  function reconcileWishlistCards(documentObject, handles) {
    if (!documentObject || typeof documentObject.querySelectorAll !== 'function') return;
    var cards = documentObject.querySelectorAll('[data-wishlist-added]');
    Array.prototype.forEach.call(cards, function(card) {
      var control = typeof card.querySelector === 'function'
        ? card.querySelector(WISHLIST_SELECTOR)
        : null;
      var handle = control && typeof control.getAttribute === 'function'
        ? String(control.getAttribute('data-product-handle') || '').trim()
        : '';
      if (handle && handles.indexOf(handle) >= 0) return;
      if (typeof card.remove === 'function') card.remove();
      else if (card.parentNode) card.parentNode.removeChild(card);
    });
  }

  function syncWishlistUi(root, documentObject, handles) {
    var normalized = normalizedHandles(handles);
    syncCount(documentObject, normalized.length);
    syncControls(root, documentObject, normalized);
    reconcileWishlistCards(documentObject, normalized);
    updatePageState(root, documentObject);
  }

  function toggleHandle(root, documentObject, handle) {
    if (!root || !handle) return null;
    var handles = readStoredHandles(root);
    var index = handles.indexOf(handle);
    var added = index < 0;
    if (added) handles.push(handle);
    else handles.splice(index, 1);
    if (!writeStoredHandles(root, handles)) return null;
    if (!added) removeWishlistCard(documentObject, handle);
    syncWishlistUi(root, documentObject, handles);
    return { added: added, handles: handles };
  }

  function removeStoredHandle(root, documentObject, handle) {
    var handles = readStoredHandles(root);
    var index = handles.indexOf(handle);
    if (index < 0) return true;
    handles.splice(index, 1);
    if (!writeStoredHandles(root, handles)) return false;
    removeWishlistCard(documentObject, handle);
    syncWishlistUi(root, documentObject, handles);
    return true;
  }

  function persistHandle(root, documentObject, handle) {
    if (!root || !handle) return false;
    var handles = readStoredHandles(root);
    if (handles.indexOf(handle) < 0) handles.push(handle);
    if (!writeStoredHandles(root, handles)) return false;
    syncWishlistUi(root, documentObject, handles);
    return true;
  }

  function normalizePersistedWishlist(root, documentObject) {
    var handles = readStoredHandles(root);
    if (!writeStoredHandles(root, handles)) return false;
    syncWishlistUi(root, documentObject, handles);
    return true;
  }

  function normalizeForLifecycle(root, documentObject) {
    if (normalizePersistedWishlist(root, documentObject)) return true;
    var state = stateFor(documentObject);
    state.pageErrors = Math.max(1, state.pageErrors);
    updatePageState(root, documentObject);
    return false;
  }

  function clearPersistedWishlist(root, documentObject) {
    try {
      if (root && root.localStorage) root.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // The in-memory reset in the legacy controller still runs if storage is unavailable.
    }
    syncWishlistUi(root, documentObject, []);
  }

  function noticeMessage(root) {
    var strings = root && root.theme && root.theme.strings;
    return strings && strings.cookie_preferences_error
      ? strings.cookie_preferences_error
      : 'Cookie preferences are temporarily unavailable.';
  }

  function showNotice(root, documentObject) {
    if (!documentObject || !documentObject.body || typeof documentObject.createElement !== 'function') return;
    var state = stateFor(documentObject);
    var notice = typeof documentObject.querySelector === 'function'
      ? documentObject.querySelector('[data-enigma-wishlist-status]')
      : null;
    if (!notice) {
      notice = documentObject.createElement('div');
      notice.className = 'enigma-wishlist-status';
      notice.setAttribute('data-enigma-wishlist-status', '');
      notice.setAttribute('role', 'alert');
      notice.setAttribute('aria-live', 'assertive');
      documentObject.body.appendChild(notice);
    }
    notice.textContent = noticeMessage(root);
    notice.hidden = false;
    if (state.noticeTimer && root && typeof root.clearTimeout === 'function') {
      root.clearTimeout(state.noticeTimer);
    }
    if (root && typeof root.setTimeout === 'function') {
      state.noticeTimer = root.setTimeout(function() {
        notice.hidden = true;
      }, 5000);
    }
  }

  function setPageState(documentObject, name) {
    if (!documentObject || typeof documentObject.querySelector !== 'function') return;
    var page = documentObject.querySelector('[data-wishlist-page]');
    if (!page) return;
    var loading = documentObject.querySelector('[data-wishlist-loading]');
    var empty = documentObject.querySelector('[data-wishlist-empty]');
    var error = documentObject.querySelector('[data-wishlist-error]');
    var container = documentObject.querySelector('[data-wishlist-container]');
    var feedback = documentObject.defaultView && documentObject.defaultView.EnigmaContentFeedback;
    var indicator = loading && (loading.querySelector('p') || loading);
    var previous = page.getAttribute('data-wishlist-state');
    if (loading && feedback && name === 'loading') {
      loading.hidden = false;
      if (previous !== 'loading') feedback.begin(indicator);
    } else if (loading && feedback && previous === 'loading' && (name === 'ready' || name === 'empty')) {
      loading.hidden = false;
      feedback.finish(indicator, function () { loading.hidden = true; });
    } else if (loading && !(indicator && indicator.getAttribute('data-content-feedback') === 'complete' && (name === 'ready' || name === 'empty'))) {
      if (feedback) feedback.cancel(indicator);
      loading.hidden = name !== 'loading';
    }
    if (empty) empty.hidden = name !== 'empty';
    if (error) error.hidden = name !== 'error';
    setAttributeIfChanged(page, 'data-wishlist-state', name);
    setAttributeIfChanged(page, 'aria-busy', name === 'loading' ? 'true' : 'false');
    setAttributeIfChanged(container, 'aria-busy', name === 'loading' ? 'true' : 'false');
  }

  function updatePageState(root, documentObject) {
    if (!documentObject || typeof documentObject.querySelector !== 'function') return;
    var page = documentObject.querySelector('[data-wishlist-page]');
    if (!page) return;
    var state = stateFor(documentObject);
    var container = documentObject.querySelector('[data-wishlist-container]');
    if (state.pagePending > 0) {
      setPageState(documentObject, 'loading');
      return;
    }
    if (state.pageErrors > 0) {
      setPageState(documentObject, 'error');
      return;
    }
    if (container && container.children && container.children.length > 0) {
      setPageState(documentObject, 'ready');
      return;
    }
    if (!state.ready) {
      setPageState(documentObject, 'loading');
      return;
    }
    if (!state.allowed || readStoredHandles(root).length === 0) {
      setPageState(documentObject, 'empty');
      return;
    }
    setPageState(documentObject, state.pageLoaded > 0 ? 'empty' : 'loading');
  }

  function htmlEscape(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeLegacyProduct(root, product) {
    if (!product || typeof product !== 'object') return product;
    var normalized = {};
    Object.keys(product).forEach(function(key) {
      normalized[key] = product[key];
    });

    var recoveredImage = String(product.type || '').trim().toLowerCase() === 'yugioh single' && root && root.EnigmaYgoImageRegistry && root.EnigmaYgoImageRegistry[String(product.id)];
    var source = product.featured_image || recoveredImage || (root && root.productNoImagePlaceholderSource) || '';
    if (!(typeof source === 'object' && source !== null && source.alt !== undefined)) {
      var compatibleSource = new String(source);
      compatibleSource.alt = htmlEscape(product.title || '');
      normalized.featured_image = compatibleSource;
    }

    var productType = String(product.type || '').trim().toLowerCase();
    var variants = Array.isArray(product.variants) ? product.variants : [];
    if (SINGLE_CARD_TYPES[productType] && variants.length > 0) {
      var preferredVariant = variants.find(function(variant) { return variant.available; }) || variants[0];
      if (preferredVariant && preferredVariant.price != null) {
        var preferredPrice = Number(preferredVariant.price);
        var preferredCompareAtPrice = Number(preferredVariant.compare_at_price);
        normalized.price = preferredVariant.price;
        normalized.price_min = preferredVariant.price;
        normalized.compare_at_price_min = preferredCompareAtPrice > preferredPrice
          ? preferredVariant.compare_at_price
          : preferredVariant.price;
      }
    }

    return normalized;
  }

  function productHandleFromUrl(url) {
    if (typeof url !== 'string') return '';
    var match = url.match(/\/products\/([^/?]+)\.js(?:[?#]|$)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  function refineWishlistCard(root, documentObject, product) {
    if (!product || !documentObject || typeof documentObject.querySelectorAll !== 'function') return;
    var handle = String(product.handle || '').trim();
    var page = documentObject.querySelector('[data-wishlist-page]');
    if (!handle || !page) return;
    var card = Array.prototype.find.call(documentObject.querySelectorAll('[data-wishlist-added]'), function(node) {
      var control = node.querySelector(WISHLIST_SELECTOR);
      return control && control.getAttribute('data-product-handle') === handle;
    });
    if (!card) return;
    var singleTypes = ['magic single', 'yugioh single', 'one piece single', 'dragon ball super singles', 'pokÃ©mon single', 'digimon single', 'flesh and blood single'];
    if (root.EnigmaRecentCard) {
      var item = card.querySelector('.item-product');
      var offerSlot = card.querySelector('.product__info');
      if (item && offerSlot) {
        var isSingle = singleTypes.indexOf(String(product.type || product.product_type || '').trim().toLowerCase()) !== -1;
        var savedHeart = card.querySelector(WISHLIST_SELECTOR);
        if (!isSingle && savedHeart) item.appendChild(savedHeart);
        // Called only inside the existing consent/generation-checked renderer.
        // Retain the wishlist wrapper and image recovery, then load the common offer.
        item.setAttribute('data-enigma-viewer-state', 'unified');
        item.setAttribute('data-enigma-single-instance', 'wishlist-' + String(product.id));
        var productPath = '/products/' + encodeURIComponent(handle);
        if (root.EnigmaLocale) productPath = root.EnigmaLocale.localizePath(productPath);
        offerSlot.setAttribute('data-enigma-recent-card', handle);
        offerSlot.setAttribute('data-enigma-recent-product-id', String(product.id));
        offerSlot.setAttribute('data-enigma-recent-url', productPath);
        // Preserve a safe product link if the offer request fails.
        var fallback = documentObject.createElement('a');
        fallback.href = productPath;
        fallback.textContent = String(product.title || handle);
        fallback.setAttribute('data-enigma-recent-fallback', '');
        offerSlot.replaceChildren(fallback);
        if (root.EnigmaRecentCard) root.EnigmaRecentCard.refresh(offerSlot);
        return;
      }
    }
    var available = product.available === true;
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var label = function(name, fallback) { return page.getAttribute('data-wishlist-' + name) || fallback; };
    var action = card.querySelector('.btnProductQuickview');
    if (action) {
      action.classList.remove('btnProductQuickview', 'mt-xs-40');
      action.classList.add('enigma-wishlist-product-link');
      action.removeAttribute('data-url');
      action.removeAttribute('data-product-url');
      action.textContent = available
        ? (variants.length > 1 ? label('choose', 'Scegli la variante') : label('buy', 'Acquista'))
        : label('view-soldout', 'Vedi prodotto esaurito');
      action.setAttribute('aria-label', action.textContent + ': ' + String(product.title || ''));
    }
    var creation = card.querySelector('.product__created');
    if (creation) creation.remove();
    var info = card.querySelector('.product__info');
    if (info && !info.querySelector('.enigma-wishlist-availability')) {
      var badge = documentObject.createElement('span');
      badge.className = 'enigma-wishlist-availability';
      badge.setAttribute('data-available', String(available));
      badge.textContent = available ? label('available', 'Disponibile') : label('soldout', 'Esaurito');
      info.appendChild(badge);
    }
    if (Number(product.price_min) === 0 && !available) {
      var price = card.querySelector('[data-price-grid]');
      if (price) price.textContent = label('no-price', 'Prezzo da confermare');
    }
  }

  function isWishlistRendererUrl(url) {
    return typeof url === 'string' && /[?&]enigma_wishlist=1(?:[&#]|$)/.test(url);
  }

  function settleProductRequest(root, documentObject, handle, successful, status) {
    var state = stateFor(documentObject);
    state.pagePending = Math.max(0, state.pagePending - 1);
    if (successful) {
      state.pageLoaded += 1;
    } else if (status === 404 || status === 410) {
      removeStoredHandle(root, documentObject, handle);
    } else {
      state.pageErrors += 1;
    }
    updatePageState(root, documentObject);
  }

  function wishlistCardExists(documentObject, handle) {
    if (!documentObject || typeof documentObject.querySelectorAll !== 'function') return false;
    return Array.prototype.some.call(
      documentObject.querySelectorAll('[data-wishlist-added]'),
      function(card) {
        var control = card && typeof card.querySelector === 'function'
          ? card.querySelector(WISHLIST_SELECTOR)
          : null;
        return !!control && String(control.getAttribute('data-product-handle') || '').trim() === handle;
      }
    );
  }

  function reloadWishlistPageForMissingHandles(root, documentObject) {
    if (!documentObject || typeof documentObject.querySelector !== 'function'
      || !documentObject.querySelector('[data-wishlist-page]')) return false;
    if (consentStatusSync(root, documentObject) !== 'allowed') return false;
    var handles = readStoredHandles(root);
    var missing = handles.some(function(handle) {
      return !wishlistCardExists(documentObject, handle);
    });
    if (!missing || !root || !root.location || typeof root.location.reload !== 'function') return false;
    root.location.reload();
    return true;
  }

  function resolvedRequest() {
    return {
      done: function(callback) {
        if (typeof callback === 'function') callback();
        return this;
      },
      fail: function() { return this; }
    };
  }

  function installProductRequestBridge(root, documentObject) {
    var jquery = root && root.jQuery;
    if (!jquery || typeof jquery.getJSON !== 'function' || jquery.getJSON.__enigmaWishlistBridge) return;
    var originalGetJSON = jquery.getJSON;

    function bridgedGetJSON(url) {
      var handle = productHandleFromUrl(url);
      var markedRendererRequest = isWishlistRendererUrl(url);
      if (!markedRendererRequest) return originalGetJSON.apply(this, arguments);
      var state = stateFor(documentObject);
      var container = documentObject && typeof documentObject.querySelector === 'function'
        ? documentObject.querySelector('[data-wishlist-container]')
        : null;
      var currentConsent = consentStatusSync(root, documentObject);
      if (handle && container && currentConsent !== 'allowed') {
        if (currentConsent === 'denied') syncFromCurrentConsent(root, documentObject);
        else {
          markConsentUnknown(root, documentObject);
          prepare(root, documentObject);
        }
        return resolvedRequest();
      }
      var canReadWishlist = currentConsent === 'allowed';
      var storedAtStart = canReadWishlist ? readStoredHandles(root) : [];
      var tracksWishlist = !!handle && storedAtStart.indexOf(handle) >= 0
        && !!container;
      if (!tracksWishlist) return resolvedRequest();

      if (
        state.pagePending > 0 &&
        state.pageLoaded > 0 &&
        container && container.children && container.children.length === 0
      ) {
        state.renderGeneration += 1;
        state.pagePending = 0;
        state.pageErrors = 0;
        state.pageLoaded = 0;
        state.productRequests = Object.create(null);
      }
      if (state.productRequests[handle]) {
        return state.productRequests[handle].request || resolvedRequest();
      }
      if (wishlistCardExists(documentObject, handle)) {
        updatePageState(root, documentObject);
        return resolvedRequest();
      }
      if (state.pagePending === 0) {
        state.renderGeneration += 1;
        state.pageErrors = 0;
        state.pageLoaded = 0;
        state.productRequests = Object.create(null);
      }
      var record = { generation: state.renderGeneration, request: null };
      state.productRequests[handle] = record;
      state.pagePending += 1;
      updatePageState(root, documentObject);

      var args = Array.prototype.slice.call(arguments);
      var callbackIndex = typeof args[1] === 'function' ? 1 : 2;
      var originalCallback = args[callbackIndex];
      var settled = false;
      var settle = function(successful, status) {
        if (settled) return;
        settled = true;
        if (state.productRequests[handle] === record) delete state.productRequests[handle];
        if (record.generation !== state.renderGeneration) return;
        settleProductRequest(root, documentObject, handle, successful, status || 0);
      };

      if (typeof originalCallback === 'function') {
        args[callbackIndex] = function(product) {
          if (record.generation !== state.renderGeneration) return undefined;
          var currentConsent = consentStatusSync(root, documentObject);
          if (currentConsent !== 'allowed') {
            if (currentConsent === 'denied') syncFromCurrentConsent(root, documentObject);
            else markConsentUnknown(root, documentObject);
            settle(false, 0);
            return undefined;
          }
          var handles = readStoredHandles(root);
          if (handles.indexOf(handle) < 0 || wishlistCardExists(documentObject, handle)) {
            settle(true, 0);
            return undefined;
          }
          var callbackArgs = Array.prototype.slice.call(arguments);
          callbackArgs[0] = normalizeLegacyProduct(root, product);
          try {
            var result = originalCallback.apply(this, callbackArgs);
            refineWishlistCard(root, documentObject, product);
            settle(true, 0);
            return result;
          } catch (error) {
            settle(false, 0);
            if (root && root.console && typeof root.console.error === 'function') {
              root.console.error('[Enigma wishlist] Impossibile renderizzare il prodotto.', error);
            }
            return undefined;
          }
        };
      }

      var request;
      try {
        request = originalGetJSON.apply(this, args);
        record.request = request;
      } catch (error) {
        settle(false, 0);
        throw error;
      }
      if (request && typeof request.done === 'function') {
        request.done(function() { settle(true, 0); });
      }
      if (request && typeof request.fail === 'function') {
        request.fail(function(xhr) { settle(false, xhr && Number(xhr.status)); });
      }
      return request;
    }

    bridgedGetJSON.__enigmaWishlistBridge = true;
    bridgedGetJSON.__enigmaWishlistOriginal = originalGetJSON;
    jquery.getJSON = bridgedGetJSON;
  }

  function showAddedPopup(root, documentObject, control) {
    if (!documentObject || typeof documentObject.querySelector !== 'function') return;
    var modal = documentObject.querySelector('.loading-modal');
    if (!modal) return;
    var context = typeof control.closest === 'function'
      ? (control.closest('.product-single') || control.closest('.item-product') || control.closest('.enigma-home-product-card'))
      : null;
    var titleSource = context && typeof context.querySelector === 'function'
      ? context.querySelector('.product-single__title, .product__title, .enigma-home-product-card__title')
      : null;
    var imageSource = context && typeof context.querySelector === 'function'
      ? context.querySelector('.thumbItem img, .proFeaturedImage img, .product__thumbnail, .enigma-home-product-card__media img')
      : null;
    var modalTitle = modal.querySelector && modal.querySelector('.product-title');
    var modalImage = modal.querySelector && modal.querySelector('.product-image');
    var modalButton = modal.querySelector && modal.querySelector('.btn-wishlist');
    if (modalTitle && titleSource) modalTitle.textContent = titleSource.textContent || '';
    if (modalImage && imageSource) {
      var imageUrl = imageSource.currentSrc || imageSource.getAttribute('src') || '';
      if (imageUrl) modalImage.setAttribute('src', imageUrl);
      modalImage.removeAttribute('srcset');
    }
    if (modalButton) modalButton.hidden = false;
    modal.style.opacity = '1';
    modal.style.visibility = 'visible';
    modal.style.transform = 'translateX(0)';
    modal.style.transition = 'all 0.3s';
    if (modal.classList) modal.classList.add('novload');
    if (root && typeof root.setTimeout === 'function') {
      root.setTimeout(function() {
        modal.style.opacity = '0';
        modal.style.visibility = 'hidden';
        modal.style.transform = 'translateX(410px)';
        if (modal.classList) modal.classList.remove('novload');
      }, 5000);
    }
  }

  function scheduleAuthoritativeReconcile(root, documentObject, handles, generation) {
    var reconcile = function() {
      var state = stateFor(documentObject);
      if (!state.allowed || state.consentGeneration !== generation) return;
      var status = consentStatusSync(root, documentObject);
      if (status === 'denied') {
        syncFromCurrentConsent(root, documentObject);
        return;
      }
      if (!writeStoredHandles(root, handles)) return;
      syncWishlistUi(root, documentObject, handles);
    };
    if (root && typeof root.setTimeout === 'function') root.setTimeout(reconcile, 0);
    else reconcile();
  }

  function markConsentUnknown(root, documentObject) {
    var state = stateFor(documentObject);
    state.allowed = false;
    state.consentKnown = false;
    state.consentUnavailable = true;
    state.ready = false;
    syncCount(documentObject, 0);
    syncControls(root, documentObject, []);
    reconcileWishlistCards(documentObject, []);
    if (documentObject && typeof documentObject.querySelector === 'function'
      && documentObject.querySelector('[data-wishlist-page]')) {
      state.pageErrors = Math.max(1, state.pageErrors);
      updatePageState(root, documentObject);
    }
  }

  function prepare(root, documentObject) {
    var state = stateFor(documentObject);
    if (state.ready && state.consentKnown) return Promise.resolve(state.allowed);
    if (state.readyPromise) return state.readyPromise;
    var generation = state.consentGeneration;

    var privacy = privacyControllerFor(root, documentObject);
    if (!privacy || typeof privacy.customerPrivacyApiFor !== 'function') {
      markConsentUnknown(root, documentObject);
      return Promise.resolve(false);
    }

    var requestPromise = privacy.customerPrivacyApiFor(root).then(function(api) {
      if (state.consentGeneration !== generation) {
        if (state.readyPromise === requestPromise) state.readyPromise = null;
        return state.allowed;
      }
      var status = consentStatusFromApi(api);
      if (status === 'unknown') {
        if (state.readyPromise === requestPromise) state.readyPromise = null;
        markConsentUnknown(root, documentObject);
        return false;
      }
      var allowed = status === 'allowed';
      state.allowed = allowed;
      state.consentKnown = true;
      state.consentUnavailable = false;
      state.ready = true;
      state.pageErrors = 0;
      if (state.readyPromise === requestPromise) state.readyPromise = null;
      if (allowed) normalizeForLifecycle(root, documentObject);
      else clearPersistedWishlist(root, documentObject);
      return allowed;
    }, function() {
      if (state.consentGeneration !== generation) {
        if (state.readyPromise === requestPromise) state.readyPromise = null;
        return state.allowed;
      }
      if (state.readyPromise === requestPromise) state.readyPromise = null;
      markConsentUnknown(root, documentObject);
      return false;
    });
    state.readyPromise = requestPromise;
    return state.readyPromise;
  }

  function blockLegacyClick(event) {
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function nowFor(root) {
    if (root && root.Date && typeof root.Date.now === 'function') return root.Date.now();
    return Date.now();
  }

  function resetProductWave(state) {
    state.renderGeneration += 1;
    state.pagePending = 0;
    state.pageErrors = 0;
    state.pageLoaded = 0;
    state.productRequests = Object.create(null);
  }

  function queuePending(root, documentObject, control, handle) {
    var state = stateFor(documentObject);
    var now = nowFor(root);
    state.pending = state.pending.filter(function(item) {
      return item && item.expiresAt > now && item.control && item.control.isConnected !== false;
    });
    var existing = state.pending.find(function(item) {
      return item.handle === handle;
    });
    if (existing) {
      existing.control = control;
      existing.expiresAt = now + PENDING_TTL_MS;
      return;
    }
    state.pending.push({
      control: control,
      expiresAt: now + PENDING_TTL_MS,
      handle: handle
    });
  }

  function hasPending(root, documentObject, control, handle) {
    var now = nowFor(root);
    return stateFor(documentObject).pending.some(function(item) {
      return item
        && item.control === control
        && item.handle === handle
        && item.expiresAt > now
        && item.control.isConnected !== false;
    });
  }

  function clearPending(documentObject) {
    var state = stateFor(documentObject);
    state.pending = [];
    state.replaying = null;
  }

  function replayPending(root, documentObject) {
    var state = stateFor(documentObject);
    var now = nowFor(root);
    var generation = state.consentGeneration;
    var pending = state.pending.filter(function(item) {
      return item && item.expiresAt > now && item.control && item.control.isConnected !== false;
    });
    state.pending = [];
    if (!pending.length) return false;

    var replay = function() {
      if (!state.allowed || state.consentGeneration !== generation) return;
      if (consentStatusSync(root, documentObject) === 'denied') {
        syncFromCurrentConsent(root, documentObject);
        return;
      }
      pending.forEach(function(item) {
        if (
          !state.allowed ||
          state.consentGeneration !== generation ||
          consentStatusSync(root, documentObject) === 'denied' ||
          item.expiresAt <= nowFor(root) ||
          item.control.isConnected === false ||
          typeof item.control.getAttribute !== 'function' ||
          String(item.control.getAttribute('data-product-handle') || '').trim() !== item.handle ||
          typeof item.control.click !== 'function'
        ) return;

        state.replaying = {
          control: item.control,
          generation: generation,
          handle: item.handle
        };
        try {
          item.control.click();
        } finally {
          state.replaying = null;
        }
      });
    };
    if (root && typeof root.setTimeout === 'function') root.setTimeout(replay, 0);
    else replay();
    return true;
  }

  function requestPreferences(root, documentObject, control) {
    var state = stateFor(documentObject);
    if (state.preferencesPromise) return state.preferencesPromise;
    var privacy = privacyControllerFor(root, documentObject);
    if (!privacy || typeof privacy.openPreferences !== 'function') {
      clearPending(documentObject);
      showNotice(root, documentObject);
      return Promise.resolve(false);
    }

    state.preferencesPromise = Promise.resolve(
      privacy.openPreferences(root, documentObject, control)
    ).then(function(opened) {
      state.preferencesPromise = null;
      if (!opened) {
        clearPending(documentObject);
        showNotice(root, documentObject);
      }
      return opened === true;
    }, function() {
      state.preferencesPromise = null;
      clearPending(documentObject);
      showNotice(root, documentObject);
      return false;
    });
    return state.preferencesPromise;
  }

  function handleClick(root, documentObject, event) {
    var target = event && event.target;
    var control = target && typeof target.closest === 'function'
      ? target.closest(WISHLIST_SELECTOR)
      : null;
    if (!control) return null;

    var handle = String(control.getAttribute('data-product-handle') || '').trim();
    if (!handle) return null;
    var state = stateFor(documentObject);
    var replaying = state.replaying
      && state.allowed
      && state.replaying.control === control
      && state.replaying.handle === handle
      && state.replaying.generation === state.consentGeneration;
    var consentStatus = consentStatusSync(root, documentObject);
    var allowed = consentStatus === 'allowed' || (replaying && consentStatus === 'unknown');
    blockLegacyClick(event);

    if (allowed) {
      state.allowed = true;
      state.consentKnown = true;
      state.consentUnavailable = false;
      state.ready = true;
      var result = toggleHandle(root, documentObject, handle);
      if (!result) {
        showNotice(root, documentObject);
        return false;
      }
      // Hearts and counters confirm the update without an added-item popup.
      return result;
    }

    if (consentStatus === 'denied') {
      var newlyDenied = state.allowed || !state.consentKnown;
      if (newlyDenied) state.consentGeneration += 1;
      state.allowed = false;
      state.consentKnown = true;
      state.consentUnavailable = false;
      state.ready = true;
      if (newlyDenied) clearPending(documentObject);
      clearPersistedWishlist(root, documentObject);
    } else if (consentStatus === 'unknown') {
      markConsentUnknown(root, documentObject);
    }
    queuePending(root, documentObject, control, handle);

    if (!state.ready) {
      return prepare(root, documentObject).then(function(isAllowed) {
        if (!hasPending(root, documentObject, control, handle)) return false;
        if (isAllowed) {
          replayPending(root, documentObject);
          return true;
        }
        return requestPreferences(root, documentObject, control);
      });
    }
    return requestPreferences(root, documentObject, control);
  }

  function handleConsent(root, documentObject, event) {
    var detail = event && event.detail;
    if (!detail) return null;
    var state = stateFor(documentObject);

    if (detail.preferencesAllowed === true) {
      state.consentGeneration += 1;
      resetProductWave(state);
      state.allowed = true;
      state.consentKnown = true;
      state.consentUnavailable = false;
      state.ready = true;
      state.pageErrors = 0;
      state.readyPromise = null;
      normalizeForLifecycle(root, documentObject);
      var generation = state.consentGeneration;
      var handles = readStoredHandles(root);
      scheduleAuthoritativeReconcile(root, documentObject, handles, generation);
      replayPending(root, documentObject);
      return true;
    }
    if (detail.preferencesAllowed === false) {
      state.consentGeneration += 1;
      resetProductWave(state);
      state.allowed = false;
      state.consentKnown = true;
      state.consentUnavailable = false;
      state.ready = true;
      state.readyPromise = null;
      clearPending(documentObject);
      clearPersistedWishlist(root, documentObject);
      return false;
    }
    return null;
  }

  function syncFromCurrentConsent(root, documentObject) {
    var state = stateFor(documentObject);
    state.consentGeneration += 1;
    resetProductWave(state);
    clearPending(documentObject);
    var consentStatus = consentStatusSync(root, documentObject);
    if (consentStatus === 'unknown') {
      state.readyPromise = null;
      markConsentUnknown(root, documentObject);
      prepare(root, documentObject);
      return false;
    }
    var allowed = consentStatus === 'allowed';
    state.allowed = allowed;
    state.consentKnown = true;
    if (state.consentUnavailable) state.pageErrors = 0;
    state.consentUnavailable = false;
    state.ready = true;
    state.readyPromise = null;
    if (allowed) normalizeForLifecycle(root, documentObject);
    else clearPersistedWishlist(root, documentObject);
    return allowed;
  }

  function bindMutationSync(root, documentObject) {
    if (!root || typeof root.MutationObserver !== 'function' || !documentObject.documentElement) return;
    if (documentObject.__enigmaWishlistObserver) return;

    function syncIfAllowed() {
      var state = stateFor(documentObject);
      var status = consentStatusSync(root, documentObject);
      if (status === 'denied') {
        if (state.allowed || !state.consentKnown) syncFromCurrentConsent(root, documentObject);
        return;
      }
      if (status === 'unknown') {
        if (state.allowed || state.consentKnown) markConsentUnknown(root, documentObject);
        return;
      }
      syncWishlistUi(root, documentObject, readStoredHandles(root));
    }

    var uiObserver = new root.MutationObserver(function() {
      syncIfAllowed();
    });

    function observeUiElement(element) {
      if (!element || element.nodeType !== 1 || typeof element.matches !== 'function') return false;
      var found = false;
      if (element.matches(WISHLIST_SELECTOR)) {
        uiObserver.observe(element, { attributes: true, attributeFilter: ['class'] });
        found = true;
      }
      if (element.matches('.WishlistCount') || element.matches('.wishlist-text')) {
        uiObserver.observe(element, { childList: true, characterData: true, subtree: true });
        found = true;
      }
      if (element.matches('[data-wishlist-added]')) found = true;
      return found;
    }

    function observeUiWithin(node) {
      if (!node || node.nodeType !== 1) return false;
      var found = observeUiElement(node);
      if (typeof node.querySelectorAll !== 'function') return found;
      var controls = node.querySelectorAll(WISHLIST_SELECTOR);
      var badges = node.querySelectorAll('.WishlistCount');
      var labels = node.querySelectorAll('.wishlist-text');
      var cards = node.querySelectorAll('[data-wishlist-added]');
      Array.prototype.forEach.call(controls, observeUiElement);
      Array.prototype.forEach.call(badges, observeUiElement);
      Array.prototype.forEach.call(labels, observeUiElement);
      return found || controls.length > 0 || badges.length > 0 || labels.length > 0 || cards.length > 0;
    }

    observeUiWithin(documentObject.documentElement);
    var observer = new root.MutationObserver(function(mutations) {
      var containsWishlistUi = false;
      mutations.forEach(function(mutation) {
        if (!mutation || !mutation.addedNodes) return;
        Array.prototype.forEach.call(mutation.addedNodes, function(node) {
          if (observeUiWithin(node)) containsWishlistUi = true;
        });
      });
      if (containsWishlistUi) syncIfAllowed();
    });
    observer.observe(documentObject.documentElement, { childList: true, subtree: true });
    documentObject.__enigmaWishlistObserver = observer;
    documentObject.__enigmaWishlistUiObserver = uiObserver;
  }

  function bind(root, documentObject) {
    if (!documentObject || documentObject.__enigmaWishlistBound) return;
    documentObject.__enigmaWishlistBound = true;
    privacyControllerFor(root, documentObject);
    installProductRequestBridge(root, documentObject);
    bindMutationSync(root, documentObject);
    prepare(root, documentObject);
    documentObject.addEventListener('click', function(event) {
      handleClick(root, documentObject, event);
    }, true);
    documentObject.addEventListener('visitorConsentCollected', function(event) {
      handleConsent(root, documentObject, event);
    });
    if (root && typeof root.addEventListener === 'function') {
      root.addEventListener('storage', function(event) {
        if (!event || event.key === null || event.key === STORAGE_KEY) {
          if (syncFromCurrentConsent(root, documentObject)) {
            reloadWishlistPageForMissingHandles(root, documentObject);
          }
        }
      });
      root.addEventListener('pageshow', function(event) {
        if (event && event.persisted === true && syncFromCurrentConsent(root, documentObject)) {
          reloadWishlistPageForMissingHandles(root, documentObject);
        }
      });
    }
  }

  return {
    bind: bind,
    bindMutationSync: bindMutationSync,
    clearPersistedWishlist: clearPersistedWishlist,
    handleClick: handleClick,
    handleConsent: handleConsent,
    installProductRequestBridge: installProductRequestBridge,
    normalizedHandles: normalizedHandles,
    normalizePersistedWishlist: normalizePersistedWishlist,
    persistHandle: persistHandle,
    prepare: prepare,
    privacyControllerFor: privacyControllerFor,
    readStoredHandles: readStoredHandles,
    reloadWishlistPageForMissingHandles: reloadWishlistPageForMissingHandles,
    removeStoredHandle: removeStoredHandle,
    syncFromCurrentConsent: syncFromCurrentConsent,
    toggleHandle: toggleHandle,
    updatePageState: updatePageState
  };
});
